import React, { useEffect, useRef } from 'react';

const WistiaEmbed = ({ videoId, width = '640px', height = '360px' }) => {
  const wistiaRef = useRef(null);

  useEffect(() => {
    // Load the Wistia script if it hasn't been loaded yet.
    if (!document.getElementById('wistia-script')) {
      const script = document.createElement('script');
      script.id = 'wistia-script';
      script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="wistia_responsive_padding" style={{ position: 'relative' }}>
      <div
        className="wistia_responsive_wrapper"
        style={{
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%',
        }}
      >
        <div
          ref={wistiaRef}
          className={`wistia_embed wistia_async_${videoId} seo=false videoFoam=true`}
        >
          {/* Wistia will transform this div into the video player */}
        </div>
      </div>
    </div>
  );
};

export default WistiaEmbed;
